import { useEffect, useState } from "react";
import Emoji0 from "../../../assets/images/emoji0.svg";
import Emoji1 from "../../../assets/images/Emoji1.svg";
import Emoji2 from "../../../assets/images/Emoji2.svg";
import Emoji3 from "../../../assets/images/Emoji3.svg";
import Emoji4 from "../../../assets/images/Emoji4.svg";
import { MessageTypes } from "../HelpHub.type";

const FeedbackRating = ({
  handleRating,
  chatData,
  currentConversationId,
}: {
  handleRating: (rating: number) => void;
  chatData: MessageTypes[] | undefined;
  currentConversationId: string;
}) => {
  const FeedbackRatings = [Emoji0, Emoji1, Emoji2, Emoji3, Emoji4];

  const [feedbackRate, setFeedbackRate] = useState<number>(0);

  useEffect(() => {
    if (!!chatData && chatData?.length > 0) {
      const data = chatData.filter(
        (ele) => ele.conversationId === currentConversationId
      );
      if (data?.length > 0) {
        setFeedbackRate(data[0]?.feedbackRate || 0);
      }
    }
  }, [chatData, currentConversationId]);

  return (
    <div className="q-helphub-emojiRatingContainer">
      <div className="q-helphub-emoji-text">
        <div>We Value Your Feedback!</div>
        <div className="q-helphub-emoji-text2">
          Thank you! Before you go, could you please provide feedback on our
          chat today?
        </div>
      </div>
      <div className="emojiRatingContainer2">
        {FeedbackRatings.map((emoji, index) => (
          <div
            className="emojiStyle2"
            key={index}
            onClick={() => {
              if (feedbackRate === 0) {
                handleRating(index + 1);
                setFeedbackRate(index + 1);
              }
            }}
            style={{
              borderColor:
                feedbackRate !== index + 1 && feedbackRate !== 0 ? "gray" : "",
              backgroundColor:
                feedbackRate !== index + 1 && feedbackRate !== 0
                  ? "#E0E0E0"
                  : feedbackRate === index + 1
                  ? "#FFDD7CBF"
                  : "",
              opacity:
                feedbackRate !== index + 1 && feedbackRate !== 0 ? 0.5 : 1,
              pointerEvents: feedbackRate > 0 ? "none" : "auto", 

            }}
            aria-disabled={feedbackRate > 0}
          >
            <img
              src={emoji}
              style={{
                width: "24px",
                height: "24px",
                filter:
                  feedbackRate !== index + 1 && feedbackRate !== 0
                    ? "grayscale(100%)"
                    : "",
              }}
              alt={`emoji${index}`}
            />
          </div>
        ))}
      </div>
      <div className="q-helphub-emoji-text3">
        <div>Not satisfied</div>
        <div>Very satisfied</div>
      </div>
    </div>
  );
};

export default FeedbackRating;
